<template>
  <span>
    {{ dateTimeUTC }}
  </span>
</template>

<script>
import { useStore } from "vuex";
import { computed } from "vue";

export default {
  props: ["timestamp"],
  setup(props) {
    const store = useStore();
    const dateTimeUTC = computed(() => {
      if (props.timestamp == null) return "";
      const zoneinfo = store.getters.zoneinfo;
      const HOURS_IN_SECONDS = zoneinfo * 60 * 60;
      const newTimestamp = props.timestamp + HOURS_IN_SECONDS;

      // 新しいUNIXタイムスタンプをDateオブジェクトに変換（UTCベース）
      const newDate = new Date(newTimestamp * 1000); // ミリ秒に変換

      // UTCベースで年、月、日、時間、分、秒を取得
      const year = newDate.getUTCFullYear();
      const month = newDate.getUTCMonth() + 1; // 月は0から始まるため、1を加える
      const day = newDate.getUTCDate();
      const hours = newDate.getUTCHours();
      const minutes = newDate.getUTCMinutes();
      const seconds = newDate.getUTCSeconds();

      // UTC日時の文字列を形成
      const dateTimeUTC = `${year}-${month
        .toString()
        .padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")} ${hours
        .toString()
        .padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

      return dateTimeUTC;
    });

    return {
      dateTimeUTC,
    };
  },
};
</script>
